import React from 'react';
import {
  DashboardShell,
  StatCards,
  SimpleBarChart,
  DataTable,
  WalletCta,
  formatPoints,
  downlineColumns,
} from './DashboardShared';

const ExecutiveTemplate = ({ data }) => {
  const cards = data.cards || {};
  const hasNetwork = data.has_mlm_node;

  return (
    <DashboardShell
      title={`${data.company.name} — Executive Overview`}
      subtitle="Company health and commission activity"
      data={data}
    >
      <StatCards
        items={[
          { label: 'Members in scope', value: cards.members_count ?? 0 },
          { label: 'Points this month', value: formatPoints(cards.commissions_this_month) },
          { label: 'Points last month', value: formatPoints(cards.commissions_last_month) },
          {
            label: data.company.is_mother_company ? 'Wallet liability' : 'Points credited',
            value: formatPoints(
              data.company.is_mother_company ? cards.wallet_liability : cards.points_credited
            ),
          },
          { label: 'Pending approvals', value: cards.pending_approvals ?? 0 },
        ]}
      />

      {data.monthly_chart?.length > 0 && (
        <section className="cd-panel">
          <h2 className="cd-panel-title">Commission volume (last 6 months)</h2>
          <SimpleBarChart data={data.monthly_chart} />
        </section>
      )}

      {data.product_mix_chart?.length > 0 && (
        <section className="cd-panel">
          <h2 className="cd-panel-title">Sales by product</h2>
          <SimpleBarChart data={data.product_mix_chart} />
        </section>
      )}

      <DataTable
        title={data.company.is_mother_company ? 'Sister companies' : 'Offices'}
        columns={[
          { key: 'name', label: 'Name' },
          { key: 'members_count', label: 'Members' },
          {
            key: 'points_this_month',
            label: 'Points (month)',
            render: (row) => formatPoints(row.points_this_month),
          },
        ]}
        rows={data.breakdown || []}
        emptyMessage="No breakdown data available."
      />

      {hasNetwork && (
        <DataTable
          title="People below you"
          columns={downlineColumns}
          rows={data.team || []}
          emptyMessage="No one is assigned under you in the commission tree yet."
        />
      )}

      <DataTable
        title="Recent commission events"
        columns={[
          { key: 'date', label: 'Date', render: (row) => row.date?.split(' ')[0] ?? '—' },
          { key: 'product_name', label: 'Product' },
          { key: 'service_name', label: 'Sale type' },
          { key: 'seller_name', label: 'Sold by', render: (row) => row.seller_name ?? '—' },
          { key: 'user_name', label: 'Credited to' },
          {
            key: 'amount',
            label: 'Points',
            render: (row) => `+${formatPoints(row.amount)}`,
          },
        ]}
        rows={data.recent_commissions || []}
      />

      <StatCards
        items={[
          {
            label: 'Your wallet balance',
            value: formatPoints(data.wallet_balance),
            hint: 'Unified across all companies',
          },
        ]}
      />
      <WalletCta />
    </DashboardShell>
  );
};

export default ExecutiveTemplate;
